/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import React, { useContext } from "react";
import { i18nContext, servicesContext } from "./table-context";
import { format } from "../../utils/locales";
import vaultUtil from "../../utils/vault-util";
import AppConfigPropertyDisplayValue from "./Properties/AppConfig/AppConfigPropertyDisplayValue";
import IntegrationPropertyDisplayValue from "./Properties/IntegrationPropertyDisplayValue";
import SecretDisplayValue from "./SecretDisplayValue";
import { PROP_APPCONFIG, PROP_ENUM, PROP_INTEGRATION, PROP_SECURE } from "./Constants";
function PropertyTableRowDisplayValue(_ref) {
  var _property$type;
  var isLoadingToolchainServices = _ref.isLoadingToolchainServices,
    property = _ref.property,
    showNotification = _ref.showNotification;
  var i18n = useContext(i18nContext);
  var toolchainServices = useContext(servicesContext);
  var propertyType = (_property$type = property.type) === null || _property$type === void 0 ? void 0 : _property$type.toUpperCase();
  if (propertyType === PROP_INTEGRATION) {
    return /*#__PURE__*/React.createElement(IntegrationPropertyDisplayValue, {
      isLoading: isLoadingToolchainServices,
      property: property
    });
  }
  if (propertyType === PROP_APPCONFIG) {
    return /*#__PURE__*/React.createElement(AppConfigPropertyDisplayValue, {
      property: property
    });
  }
  if (propertyType === PROP_SECURE) {
    var warning;
    if (!isLoadingToolchainServices) {
      var reference = vaultUtil.parseValue(property.value);
      if (reference && reference.provider !== vaultUtil.CRN_PROVIDER_TYPE && reference.provider !== vaultUtil.REF_SM_PROVIDER_TYPE && toolchainServices.length && !toolchainServices.some(function (service) {
        return service.parameters.label === reference.toolcardName;
      })) {
        warning = format(i18n.messages.warningPropertySecureIntegrationMissing, [reference.toolcardName]);
        if (showNotification) {
          // This section currently only used by pipeline-ui
          showNotification(reference);
        }
      }
    }
    return property.value ? /*#__PURE__*/React.createElement("div", {
      className: "property-display-value-wrapper"
    }, /*#__PURE__*/React.createElement(SecretDisplayValue, {
      value: property.value,
      warning: warning
    })) : "";
  }
  var displayValue;
  var tooltip = property.value || "";
  if (propertyType === PROP_ENUM) {
    var selectedItem = Object.keys(property.value || []).find(function (item) {
      return property.value[item];
    });
    displayValue = selectedItem || "";
    tooltip = displayValue;
  } else {
    var lines = (property.value || "").split("\n");
    displayValue = lines[0];
    if (lines.length > 1) {
      displayValue = "".concat(displayValue, "\u2026");
    }
  }
  return /*#__PURE__*/React.createElement("span", {
    className: "property-display-value-wrapper"
  }, /*#__PURE__*/React.createElement("span", {
    className: "property-display-value",
    "data-type": propertyType,
    title: tooltip
  }, displayValue));
}
export default PropertyTableRowDisplayValue;